/**
 * Loc L2 configuration for SEO category+location pages (SOW Section 4).
 * Data lives in seoLocations.json (plain JSON, requirable as-is from the
 * CommonJS server code — see server/api/jobs/seoEligibility.job.js, which
 * derives the same JAKARTA_LOC_L1 grouping independently from that same
 * JSON file rather than importing this ESM module).
 *
 * `enumValue` is the exact, verbatim value of the `product_loction` public
 * listing field (Console-configured — not discoverable from static code,
 * read directly from the live `/listings/listing-fields.json` asset). The
 * typos/inconsistent casing ('jkt-Barat' capitalized, 'tangeran-*' missing a
 * 'g', 'Karawang' capitalized while siblings are lowercase) are real and
 * must be used verbatim — they are what's actually stored on listings.
 *
 * Loc L1 "Jakarta" = the five `jkt-*` entries together (SOW: "Loc L1 Jakarta
 * = the combined results of Jakarta Barat, Pusat, Selatan, Timur and
 * Utara").
 */
import seoLocationsData from './seoLocations.json';

export const seoLocations = seoLocationsData;

export const JAKARTA_LOC_L1 = {
  slug: 'jakarta',
  label: 'Jakarta',
  locL2Slugs: seoLocations.filter(l => l.locL1 === 'jakarta').map(l => l.slug),
};

export const findSeoLocationBySlug = slug => seoLocations.find(l => l.slug === slug) || null;

export default seoLocations;
